/**
 * @file Renders raw HTML markup.
 */
import React from "react";

type Props = {
  html: string;
};

/**
 * Renders the given HTML markup directly into the page.
 */
const Html = ({ html }: Props): JSX.Element => {
  const markup = { __html: html };

  return (
    // eslint-disable-next-line react/no-danger
    <div dangerouslySetInnerHTML={markup} />
  );
};

export default Html;
